module.exports = __webpack_public_path__ + "img/transport-scotland-logo.7e7fbf58.jpg";